function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    showLabel,
    vertical,
    short
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => ({
    nav: {
      '&:not(:first-of-type)': _objectSpread(_objectSpread({
        borderTop: "1px solid ".concat(theme.palette.stroke.default),
        marginTop: theme.layout.size5,
        paddingTop: theme.layout.size2
      }, vertical && {
        marginTop: theme.layout.size4,
        paddingTop: theme.layout.size4
      }), short && {
        marginTop: theme.layout.size3,
        paddingTop: theme.layout.size3
      }),
      '> ul > li:nth-of-type(2)': !vertical && !short && {
        marginTop: theme.layout.size1
      }
    },
    label: {
      backgroundColor: 'transparent',
      border: 0,
      color: theme.palette.foreground.default,
      display: showLabel ? 'flex' : 'none',
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size1,
      lineHeight: theme.typography.lineHeight2,
      padding: theme.layout.size3,
      whiteSpace: 'nowrap',
      width: '100%'
    },
    li: {
      margin: "0 ".concat(theme.layout.size2)
    }
  }), [showLabel, theme, vertical, short]);
};
export default useStyles;